/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetItemDoneRequest
 */
export interface SetItemDoneRequest {
  /**
   *
   * @type {string}
   * @memberof SetItemDoneRequest
   */
  companyListItemId: string;
  /**
   *
   * @type {boolean}
   * @memberof SetItemDoneRequest
   */
  done: boolean;
}

/**
 * Check if a given object implements the SetItemDoneRequest interface.
 */
export function instanceOfSetItemDoneRequest(
  value: object,
): value is SetItemDoneRequest {
  if (
    !("companyListItemId" in value) ||
    value["companyListItemId"] === undefined
  )
    return false;
  if (!("done" in value) || value["done"] === undefined) return false;
  return true;
}

export function SetItemDoneRequestFromJSON(json: any): SetItemDoneRequest {
  return SetItemDoneRequestFromJSONTyped(json, false);
}

export function SetItemDoneRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetItemDoneRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListItemId: json["companyListItemId"],
    done: json["done"],
  };
}

export function SetItemDoneRequestToJSON(json: any): SetItemDoneRequest {
  return SetItemDoneRequestToJSONTyped(json, false);
}

export function SetItemDoneRequestToJSONTyped(
  value?: SetItemDoneRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListItemId: value["companyListItemId"],
    done: value["done"],
  };
}
